module.exports = __webpack_public_path__ + "img/logo-24.84686ac2.svg";